import { $apiWithoutClient } from 'modules/global';

import { IUserProfileResult } from '../models';

export const getUserProfileResult = (id?: string) => async () => {
  const { data } = await $apiWithoutClient.get<IUserProfileResult[]>(`/profile/result${id ? `?id=${id}` : ''}`);

  return data;
};
